module.exports = __webpack_public_path__ + "static/media/image_6.349a7976.png";